export default __webpack_public_path__ + "static/media/image5.71b025ca.jpg";